import {mobileAndTabletcheck, checkIpadPro, isIE, isEdge,isSafari} from './public/DevicesCheck.js'
import ScrollReveal from './helpers/ScrollReveal.js'
import Parallax from './public/parallax.js'
import Menu from './public/Menu.js'
import LoopMover from './public/loopMover'
import Filter from './public/Filter'

window.clint = {}

function devicesName  () {
    let body = document.querySelector('body')

    if(isSafari() === true) {
        body.classList.add('safari')
    }

    if(isIE() === true) {
        body.classList.add('isIE')
    }

    if(isEdge() === true) {
        body.classList.add('isEdge')
    }

    if(mobileAndTabletcheck() === true) {
        body.classList.add('isTouch')
        body.classList.add('isMobile')
    } else if(checkIpadPro() === true ) {
        body.classList.add('isTouch')
        body.classList.add('isIpadPro')
    }

}

function init() {

    devicesName()
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }

    if (!String.prototype.includes) {
        String.prototype.includes = function (str) {
            var returnValue = false;
          
            if (this.indexOf(str) !== -1) {
              returnValue = true;
            }
          
            return returnValue;
          }
    }

    if (!Array.prototype.includes) {
        String.prototype.includes = function (str) {
            var returnValue = false;
          
            if (this.indexOf(str) !== -1) {
              returnValue = true;
            }
          
            return returnValue;
          }
    }

    /**
     * Global Animation
     */

    this.Filter = new Filter
    this.Filter.init()

    this.scrollReveal = new ScrollReveal
    this.scrollReveal.init()

    this.parallax = new Parallax
    this.parallax.init()

    this.LoopMover = new LoopMover
    this.LoopMover.init()


    this.Menu = new Menu
    this.Menu.init()

    window.clint.reinit()
}

window.clint.reinit = function() {
    // script here
}

window.clint.destroy = function() {

}
  
window.clint.onDestroy = function(obj) {
    if(obj)
      {
          if(obj.destroy)
          {
              obj.destroy();
          }
          obj = null;
      }
  }

window.onload = init